import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=2e13376d&scoped=true"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=2e13376d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e13376d",
  null
  
)

export default component.exports